import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'mdw-loader',
  templateUrl: './loader.html',
  styleUrls: ['./loader.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class MdwLoader {}
